var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75.458 78.114 H 14.542 c -2.253 0 -4.087 -1.833 -4.087 -4.087 c 0 -3.136 1.367 -6.102 3.751 -8.138 c 1.938 -1.655 3.05 -4.067 3.05 -6.616 v -22.41 C 17.257 21.566 29.703 9.121 45 9.121 c 15.298 0 27.743 12.445 27.743 27.743 v 22.41 c 0 2.549 1.111 4.961 3.05 6.616 c 2.385 2.036 3.752 5.002 3.752 8.138 C 79.545 76.281 77.712 78.114 75.458 78.114 z M 45 11.121 c -14.194 0 -25.743 11.548 -25.743 25.743 v 22.41 c 0 3.135 -1.367 6.101 -3.751 8.138 c -1.938 1.655 -3.05 4.066 -3.05 6.616 c 0 1.15 0.936 2.087 2.087 2.087 h 60.916 c 1.15 0 2.087 -0.937 2.087 -2.087 c 0 -2.55 -1.112 -4.961 -3.051 -6.616 c -2.384 -2.037 -3.751 -5.003 -3.751 -8.138 v -22.41 C 70.743 22.669 59.195 11.121 45 11.121 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,248,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 90 c -7.063 0 -12.81 -5.746 -12.81 -12.81 c 0 -0.024 0.003 -0.089 0.004 -0.113 c 0.039 -0.541 0.493 -0.987 1.044 -0.944 c 0.542 0.024 0.965 0.459 0.955 1.001 c 0 0.018 -0.003 0.07 -0.004 0.088 C 34.19 83.15 39.04 88 45 88 c 5.96 0 10.81 -4.85 10.81 -10.81 c 0 -0.553 0.445 -1.038 0.998 -1.038 s 0.998 0.409 0.998 0.962 C 57.81 84.254 52.063 90 45 90 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,248,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 80.543 37.863 c -0.553 0 -1 -0.448 -1 -1 c 0 -14.187 -8.898 -27.144 -22.144 -32.241 c -0.516 -0.198 -0.772 -0.777 -0.574 -1.292 c 0.199 -0.516 0.781 -0.772 1.293 -0.574 c 14.011 5.392 23.425 19.099 23.425 34.107 C 81.543 37.416 81.096 37.863 80.543 37.863 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,248,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 9.457 37.863 c -0.552 0 -1 -0.448 -1 -1 c 0 -15.008 9.414 -28.715 23.425 -34.107 c 0.515 -0.198 1.094 0.059 1.292 0.574 c 0.199 0.516 -0.059 1.094 -0.574 1.292 C 19.355 9.72 10.457 22.677 10.457 36.863 C 10.457 37.416 10.009 37.863 9.457 37.863 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,248,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 11.124 c -3.067 0 -5.562 -2.495 -5.562 -5.562 C 39.438 2.495 41.933 0 45 0 c 3.066 0 5.562 2.495 5.562 5.562 C 50.562 8.628 48.066 11.124 45 11.124 z M 45 2 c -1.964 0 -3.562 1.598 -3.562 3.562 S 43.036 9.124 45 9.124 s 3.562 -1.598 3.562 -3.562 S 46.964 2 45 2 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(248,248,248)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.558835373172d875bcd7a8db3dd27d76.svg";
export { ForwardRef as ReactComponent };